import React, { useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { ArrowRightIcon } from '@assets/icons/arrowRightIcon';
import { AddIcon } from '@assets/icons/addIcon';
import BlackCheckIcon from '@assets/icons/blackCheckIcon';
import InnerLoader from '@components/InnerLoader';

const Field:React.FC<IProps> = (props) => {
  return (
    <S.Root>
      <S.GeneralRow>
      <S.Row1>
      {props.icon ?
        props.icon : 
        <AddIcon onClick={props.onIconClick} style={{cursor:'pointer', fillColor: '#8891a0', marginRight: '9px'}}/>
      }
      
      <S.Button selected={props.selected} onClick={props.onClick} style={{cursor: 'pointer',width: props.icon ? '227px' : '249px'}}>
        <S.Title>
          {props.title}
        </S.Title>
        <S.Message>
          {props.messageText?props.messageText:""}
        </S.Message>
      </S.Button>
      </S.Row1>
      <S.Row2>
      {
        props.messageText && props.messageText!=="" &&
        <S.Link onClick={props.onClearAll}>
          Clear All
        </S.Link>
      }
      </S.Row2>
      </S.GeneralRow>
      <S.Others>
      { props.messageText && !props.showSaving && <BlackCheckIcon/> }
      { props.showSaving && <InnerLoader/> }
      </S.Others>
    </S.Root>
  );
}

export default Field;